import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { MainComponent } from "./components/main/main.component";
import { HomeComponent } from "./components/shop/home/home.component";
import { DemoComponent } from "./components/demo/demo.component";

const appRoutes: Routes = [
  {
    path: "",
    redirectTo: "home/five",
    pathMatch: "full",
  },
  {
    path: "",
    component: MainComponent,
    children: [
      {
        path: "home",
        loadChildren: () =>
          import("./components/shop/shop.module").then((m) => m.ShopModule),
      },
      {
        path: "pages",
        loadChildren: () =>
          import("./components/pages/pages.module").then((m) => m.PagesModule),
      },
      {
        path: "blog",
        loadChildren: () =>
          import("./components/blog/blog.module").then((m) => m.BlogModule),
      },
    ],
  },
  {
    path: "**",
    redirectTo: "home/five",
  },
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(appRoutes, {
      useHash: true,
      anchorScrolling: "enabled",
      scrollPositionRestoration: "top",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
